import { useUserApi } from "@/hooks/apiHooks/useUserApi";
import type { UserResponse } from "@/models";
import Button from "@common/Button";
import { useState } from "react";

export const ExampleApiUsage = () => {
    const { getMeUser } = useUserApi();
    const [user, setUser] = useState<UserResponse | null>(null);

    const handleGetUser = async () => {
        const response = await getMeUser();

        setUser(response);
    };

    return (
        <div>
            <Button onClick={handleGetUser}>Get Me User</Button>

            {user && (
                <div>
                    <p>ID: {user.id}</p>
                    <p>First Name: {user.firstName}</p>
                    <p>Last Name: {user.lastName}</p>
                    <p>Email: {user.email}</p>
                </div>
            )}
        </div>
    );
};
